<template>
  <div class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggle-click="toggleSideBar" :is-active="sidebar.opened"></hamburger>

    <breadcrumb class="breadcrumb-container"></breadcrumb>

    <div class="right-menu">
      <el-tooltip effect="dark" :content="$t('navbar.screenfull')" placement="bottom">
        <screenfull class="screenfull right-menu-item"></screenfull>
      </el-tooltip>

      <lang-select class="international right-menu-item"></lang-select>

      <!-- <el-tooltip effect="dark" :content="$t('navbar.theme')" placement="bottom">
        <theme-picker class="theme-switch right-menu-item"></theme-picker>
      </el-tooltip> -->

      <el-dropdown class="name-container right-menu-item" trigger="click">
        <div class="name-wrapper">
          {{ name }}
          <el-icon><CaretBottom /></el-icon>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <router-link to="/">
              <el-dropdown-item>
                {{ $t('navbar.dashboard') }}
              </el-dropdown-item>
            </router-link>
            <router-link to="/password">
              <el-dropdown-item>
                {{ $t('navbar.password') }}
              </el-dropdown-item>
            </router-link>
            <el-dropdown-item divided>
              <span style="display: block" @click="logout">{{ $t('navbar.logOut') }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import ThemePicker from '@/components/ThemePicker'
import { CaretBottom } from '@element-plus/icons-vue'

import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import LangSelect from '@/components/LangSelect'
import Screenfull from '@/components/Screenfull'
import { captureEvent } from '@/telemetry/posthogTelemetry'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    Screenfull,
    LangSelect,
    // ThemePicker
    CaretBottom
  },
  computed: {
    ...mapGetters(['sidebar', 'name', 'avatar'])
  },
  created() {
    window.addEventListener('deviceorientation', this.deviceOrientatnionHandler)
  },
  unmounted() {
    window.removeEventListener('deviceorientation', this.deviceOrientatnionHandler)
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar')
    },
    logout() {
      captureEvent('user_logged_out')
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // In order to re-instantiate the vue-router object to avoid bugs
      })
    }
  },
  deviceOrientatnionHandler() {
    if (window.matchMedia('(max-width: 767px)').matches) {
      this.$store.dispatch('closeSideBar')
    } else {
      this.$store.dispatch('openSideBar')
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@use '@/styles/mixin';
@use '@/styles/variables';

.navbar {
  position: sticky;
  z-index: variables.$zIndexNavbar;
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  height: var(--el-menu-horizontal-height);
  top: 0;
  min-height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  background-color: var(--el-menu-bg-color);
  border-bottom: 1px solid var(--el-menu-border-color);

  .hamburger-container {
    height: var(--el-menu-horizontal-height);
    padding: 10px;
  }

  .breadcrumb-container {
    display: flex;
    align-items: center;
    float: left;
    max-width: calc(100% - 40px);
    min-height: 50px;
    line-height: 30px;
    margin: 0;

    @include mixin.for-tablet-up {
      margin-left: 10px;
      line-height: 50px;
    }
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    display: flex;
    align-items: center;
    margin-left: auto;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }

    .screenfull {
      display: none;

      @include mixin.for-desktop-up {
        display: block;
        height: 20px;
      }
    }

    .international {
      vertical-align: top;
    }

    .theme-switch {
      vertical-align: 15px;
    }

    .name-container {
      margin-right: 5px;

      @include mixin.for-tablet-up {
        margin-right: 15px;
      }

      @include mixin.for-desktop-up {
        margin-right: 30px;
      }

      .name-wrapper {
        cursor: pointer;
        position: relative;
      }
    }
  }
}
</style>
